"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeAllyManagerFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TimeAllyManagerFactory = /** @class */ (function (_super) {
    __extends(TimeAllyManagerFactory, _super);
    function TimeAllyManagerFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TimeAllyManagerFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    TimeAllyManagerFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    TimeAllyManagerFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TimeAllyManagerFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TimeAllyManagerFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TimeAllyManagerFactory;
}(contracts_1.ContractFactory));
exports.TimeAllyManagerFactory = TimeAllyManagerFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'NRTReceived',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'master',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'child',
                type: 'address',
            },
        ],
        name: 'StakingMerge',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'master',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'child',
                type: 'address',
            },
        ],
        name: 'StakingSplit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'staking',
                type: 'address',
            },
        ],
        name: 'StakingTransfer',
        type: 'event',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
            {
                internalType: 'uint32',
                name: '_startMonth',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_endMonth',
                type: 'uint32',
            },
        ],
        name: 'decreaseActiveStaking',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'defaultMonths',
        outputs: [
            {
                internalType: 'uint32',
                name: '',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_childStaking',
                type: 'address',
            },
        ],
        name: 'emitStakingMerge',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_oldOwner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_newOwner',
                type: 'address',
            },
        ],
        name: 'emitStakingTransfer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getMonthlyNRT',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getTotalActiveStaking',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
            {
                internalType: 'uint32',
                name: '_startMonth',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_endMonth',
                type: 'uint32',
            },
        ],
        name: 'increaseActiveStaking',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'initialize',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isAdminMode',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakingContract',
                type: 'address',
            },
        ],
        name: 'isStakingContractValid',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_sender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'prepaidFallback',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_reward',
                type: 'uint256',
            },
            {
                internalType: 'enum ITimeAllyManager.RewardType',
                name: '_rewardType',
                type: 'uint8',
            },
        ],
        name: 'processNrtReward',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_currentNrtMonth',
                type: 'uint32',
            },
        ],
        name: 'receiveNrt',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_owner',
                type: 'address',
            },
        ],
        name: 'removeStaking',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceAdminMode',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_receiver',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_initialIssTime',
                type: 'uint256',
            },
            {
                internalType: 'bool[]',
                name: '_claimedMonths',
                type: 'bool[]',
            },
        ],
        name: 'sendStake',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_defaultMonths',
                type: 'uint32',
            },
        ],
        name: 'setDefaultMonths',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakingTarget',
                type: 'address',
            },
        ],
        name: 'setStakingTarget',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_owner',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_initialIssTime',
                type: 'uint256',
            },
            {
                internalType: 'uint32',
                name: '_masterEndMonth',
                type: 'uint32',
            },
        ],
        name: 'splitStaking',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'stake',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'stakingTarget',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
        ],
        name: 'withdrawClaimedNrt',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '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';
//# sourceMappingURL=TimeAllyManagerFactory.js.map